import React from "react";
import { SvgProps } from "../../types";

export const FireIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 16 19"
      className={props.classNames?.join(" ") || ""}
    >
      <path
        d="M14.1222 14.645C13.466 15.6911 12.5512 16.5504 11.4662 17.14C10.387 17.7256 9.17374 18.0196 7.9462 17.993C6.8006 18.0442 5.66136 17.7968 4.6402 17.275C3.61335 16.7498 2.7387 15.9695 2.1002 15.009C-0.571804 10.439 2.3872 6.163 2.9872 5.341C3.52014 4.77075 3.89365 4.07029 4.0702 3.31C4.24785 2.54682 4.22268 1.75044 3.9972 1C5.2812 1.965 10.4272 4.258 9.5222 11.631C11.0182 10.495 12.2222 8.585 12.3682 5.415C13.7982 6.476 16.3532 10.877 14.1222 14.645Z"
        fill="transparent"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
